/* eslint no-underscore-dangle: 0 */
/* eslint camelcase: 0 */
/* eslint no-param-reassign: 0 */

export const createc_colon_lights = (block, generator) => {
  const efecto = block.getFieldValue('STAT');
  generator.loop_footer_.createc_colon_lights = '\n  checkColon();\n';
  return `efectoColon(${efecto});\n`;
};

export const createc_colon_lights_off = (block, generator) => {
  generator.loop_footer_.createc_colon_lights = '\n  checkColon();\n';
  return 'apagarLucesColon();\n';
};

export const createc_obelisco_lights = (block, generator) => {
  const color = generator.valueToCode(block, 'COLOUR', generator.ORDER_ATOMIC) || 0;
  generator.loop_footer_.createc_obelisco_lights = '\n  checkObelisco();\n';
  return `prenderLucesObelisco(${color});\n`;
};

export const createc_obelisco_lights_off = (block, generator) => {
  generator.loop_footer_.createc_obelisco_lights = '\n  checkObelisco();\n';
  return 'apagarLucesObelisco();\n';
};

export const createc_obelisco_luminaria_zona5 = (block) => {
  const estado = block.getFieldValue('STAT');
  return `Obelisco_LuminariaCalle(${estado});\n`;
};

export const createc_obelisco_screen = (block, generator) => {
  const message = block.getFieldValue('STAT');
  generator.loop_footer_.createc_obelisco_screen = '\n  checkPantallaTransito();\n';
  return `MensajeTransito(${message});\n`;
};
